module.exports = __webpack_public_path__ + "img/12.eaa1b131.png";